import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: ${(props) => (props.isFullScreen ? '100%' : '500px')};
  overflow: auto;

  /* Esconde o quadradinho que era renderizado na junção das duas barras de scroll */
  &::-webkit-scrollbar-corner {
    background: transparent;
  }

`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
  width: 100%;
  thead {
    color: ${(props) => props.theme.simpleCross.tableHeadColor};
    text-align: left;
    tr th {
      padding: 8px 12px 8px 12px;
      height: 56px;
      font-family: "Roboto";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align: center;
      background:  ${(props) => props.theme.simpleCross.tableHeadBackgroud};
      position: sticky;
      top: 0;
      z-index: 999;
      border-right: 1px solid ${(props) => props.theme.simpleCross.borderColor};
      border-left: 1px solid ${(props) => props.theme.simpleCross.borderColor};
      :nth-child(1) {
        text-align: left;
        padding-left: 24px;
      }
    }

    tr th:first-of-type {
      z-index: 9999;
      position: sticky;
      top: 0;
      left: 0;
    }

    tr th.respondentes {
      text-align: center;
    }
  }

  tbody {
    position: relative;
    .pergunta-cruzada-wrapper { 
      font-family: "Roboto";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .row {
      position: sticky;
      left: 0;
      top: 0;
      background-color: ${(props) => props.theme.simpleCross.resultCelBackground};
      z-index: 9;
      padding-left: 24px;
    }
    
    .questionTitle {
      background-color: ${(props) => props.theme.simpleCross.gradeTitleBackground};
    }

    .gradeTitle {
      position: sticky;
      left: 0;
      background-color: ${(props) => props.theme.simpleCross.gradeTitleBackground};
      z-index: 9;
      font-weight: 700;
      padding-left: 24px;
    }

    .gradeTitle-col {
      background-color: ${(props) => props.theme.simpleCross.gradeTitleBackground};
      font-weight: 700;
    }

    tr {
      font-family: "Roboto";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: ${(props) => props.theme.simpleCross.resultCelColor};
      background: ${(props) => props.theme.simpleCross.crossQuestionBackground};
      height: 32px;
      position: relative;

      th {
        background: ${(props) => props.theme.simpleCross.crossQuestionBackground};
        position: -webkit-sticky;
        position: sticky;
        top: 90px;
        text-align: left;
        height: 32px;
        z-index: 99;

        span {
          position: -webkit-sticky;
          position: sticky;
          top: 0;
          left: 24px;
        }
      }

      td:first-of-type {
        text-align: left;
      }

      td {
        padding: 2px 8px;
        min-width: 96px;
        position: relative;
        text-align: center;
        border: 1px solid ${(props) => props.theme.simpleCross.borderColor};
        background: ${(props) => props.theme.simpleCross.resultCelBackground};
        color: ${(props) => props.theme.simpleCross.resultCelColor};
      }

      td.grade-lines {
        position: sticky;
        top: 88px;
        z-index: 999;
        border: none;
        background: ${(props) => props.theme.simpleCross.crossQuestionBackground};
      }

      td.resultado-cruzamento.selecionado {
        background-color: rgb(97, 0, 130);
        color: #fff;
        font-weight: bold;
      }

      td.grade-lines:first-of-type {
        position: sticky;
        left: 0;
        top: 88px;
        z-index: 1001;
      }

      td.resultado-cruzamento {
        &:hover {
          cursor: default;
          background-color: rgba(97, 0, 130, 0.8);
          color: #fff;
          font-weight: bold;
        }
      }

      td.respondentes.resultadoNumerico {
        text-align: right;
        width: 15px;
      }

      td.respondentes.resultadoPercentual {
        text-align: left;
        width: 15px;
      }

      &:first-of-type {
        background: ${(props) => props.theme.simpleCross.crossQuestionBackground};
        color: ${(props) => props.theme.simpleCross.crossQuestionColor};
        z-index: 99;

        td {
          column-span: all;
        }
      }
    }
  }

  tfoot {
    color: ${(props) => props.theme.simpleCross.tableHeadColor};
    font-family: "Roboto";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    z-index: 999;
    height: 40px;
    max-height: 40px;
    overflow: hidden;
    box-sizing: border-box;

    tr td:nth-child(1) {
      text-align: left;
      padding-left: 24px;
    }

    tr td {
      padding: 8px 12px;
      font-size: 14px;
      font-weight: ${(props) => props.theme.simpleCross.footerResultCelFontWeight};
      position: sticky;
      z-index: 999;
      bottom: 0;
      background-color: ${(props) => props.theme.simpleCross.tableHeadBackgroud};
      border: 1px solid ${(props) => props.theme.simpleCross.borderColor};
      height: 40px;
      max-height: 40px;
    }

    tr td:first-of-type {
      z-index: 9999;
      position: sticky;
      top: 0;
      left: 0;
      font-weight: ${(props) => props.theme.simpleCross.footerTotalCelFontWeight};
    }
  }
`